'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindToSelection = exports.reducer = exports.actionTypes = undefined;

var _setItems = require('./setItems');

var _rangeTo = require('./rangeTo');

var _remove = require('./remove');

var _removeAll = require('./removeAll');

var _replace = require('./replace');

var _setSelection = require('./setSelection');

var _toggle = require('./toggle');

var _actionTypes = require('./actionTypes');

var actionTypes = _interopRequireWildcard(_actionTypes);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _selectors = require('./selectors');

var selectors = _interopRequireWildcard(_selectors);

var _bindToSelection2 = require('./bindToSelection');

var _bindToSelection3 = _interopRequireDefault(_bindToSelection2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {
  setItems: _setItems.setItemsActionCreator,
  rangeTo: _rangeTo.rangeToActionCreator,
  remove: _remove.removeActionCreator,
  removeAll: _removeAll.removeAllActionCreator,
  replace: _replace.replaceActionCreator,
  setSelection: _setSelection.setSelectionActionCreator,
  toggle: _toggle.toggleActionCreator
};

var bindToSelection = (0, _bindToSelection3.default)(actions, selectors);

exports.actionTypes = actionTypes;
exports.reducer = _reducer2.default;
exports.bindToSelection = bindToSelection;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/index.js
// module id = 44
// module chunks = 0